import { render, staticRenderFns } from "./DebtorInfo.vue?vue&type=template&id=30e6388d&scoped=true"
import script from "./DebtorInfo.vue?vue&type=script&lang=ts"
export * from "./DebtorInfo.vue?vue&type=script&lang=ts"
import style0 from "./DebtorInfo.vue?vue&type=style&index=0&id=30e6388d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6388d",
  null
  
)

export default component.exports